import {
  Grid,
  IconButton,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import {
  BtnGroupStyle,
  ContentStyle,
  DataGridListStyle,
  SearchBox,
} from "../../Theme";
import TrashIcon from "../../images/icons/TrashIcon.svg";
import { HelpGuideTooltip } from "../../components/HelpGuideTooltip";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import EditIcon from "../../images/icons/EditIcon.svg";
import NoRecords from "../../components/NoRecords";
import ShowPasswordIcon from "../../images/icons/ShowPasswordIcon.svg";
import ErrorOverlay from "../../components/ErrorOverlay";
import { v4 as uuid } from "uuid";
import useFetch from "../../CustomHooks/useFetch";
import { useEffect, useState } from "react";
import useDebounce from "../../CustomHooks/useDebounce";
import { YSButton } from "../../uikit/YSButton";
import { DialogPopup } from "../../components/DialogPopup";
import AddNewTemplate from "./AddNewTemplate";
import {
  deleteTemplate,
  templatePrescriptionList,
} from "../../Apis/TemplateApis";
import ConfirmPopup from "../../components/ConfirmPopup";
import YSSnackBar from "../../uikit/YSSnackBar";
import { useNavigate } from "react-router-dom";

export default function PrescriptionTemplateInfo() {
  const navigate = useNavigate();
  const [templateName, setTemplateName] = useState("");
  const [rowData, setRowData] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [selectionData, setSelectionData] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [deleteStateData, setDeleteStateData] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });
  const [deleteDataPopup, setDeleteDataPopup] = useState(false);
  const handleShowDeletePopupClick = () => {
    setDeleteDataPopup(true);
  };
  const handleHideDeletePopupClick = () => {
    setDeleteDataPopup(false);
  };
  const [addNewTemplatePopup, setAddNewTemplatePopup] = useState(false);
  const handleShowAddNewTemplatePopup = () => {
    setAddNewTemplatePopup(true);
  };
  const handleHideAddNewTemplatePopup = () => {
    setAddNewTemplatePopup(false);
  };
  const debouncedValue = useDebounce(templateName, 1000);

  const deleteRowData = async () => {
    try {
      const params = new URLSearchParams();
      params.append("templateId", selectionData);
      const result = await deleteTemplate(params);
      if (result?.data?.digitalRxStatusCode === 200) {
        setDeleteStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.response[0]?.message,
            variant: "success",
            open: true,
          };
        });
        fetchApi();
      } else {
        setDeleteStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (err: any) {
      setDeleteStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Try Again After Some Time!",
          variant: "error",
          open: true,
        };
      });
    }
  };
  const params = {
    doctorId: localStorage.getItem("doctorId"),
    templateName: debouncedValue,
    pageNumber: page,
    pageSize: pageSize,
  };
  const { data, loading, error, fetchApi }: any = useFetch(
    params,
    templatePrescriptionList,
    [debouncedValue, page]
  );

  const columns: GridColDef[] = [
    {
      field: "templateName",
      headerName: "Templates",
      width: 350,
      cellClassName: "w40",
      headerClassName: "w40",
    },
    {
      field: "count",
      headerName: "Count",
      width: 310,
      cellClassName: "w30",
      headerClassName: "w30",
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 100,
      cellClassName: "w30",
      headerClassName: "w30",

      renderCell: ({ row }) => {
        return (
          <>
            <Tooltip title="View">
              <IconButton
                color="primary"
                onClick={() => {
                  navigate(`${row?.id}`);
                }}
              >
                <img src={ShowPasswordIcon} alt="Show/Hide Password" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Edit">
              <IconButton
                color="primary"
                onClick={() => {
                  handleShowAddNewTemplatePopup();
                  setRowData(row);
                  setIsEdit(true);
                }}
              >
                <img src={EditIcon} alt="Edit" />
              </IconButton>
            </Tooltip>

            <Tooltip title="Delete">
              <IconButton
                color="primary"
                className="trash"
                onClick={() => {
                  handleShowDeletePopupClick();
                  setSelectionData(row?.id);
                }}
              >
                <img src={TrashIcon} alt="Delete" />
              </IconButton>
            </Tooltip>
          </>
        );
      },
    },
  ];

  const [rowCountState, setRowCountState] = useState(
    data[0]?.pagination?.totalItems || 0
  );

  useEffect(() => {
    setRowCountState((prevRowCountState: any) =>
      data[0]?.pagination?.totalItems !== undefined
        ? data[0]?.pagination?.totalItems
        : prevRowCountState
    );
  }, [data[0]?.pagination?.totalItems, setRowCountState]);

  return (
    <>
      <ContentStyle>
        <Grid
          container
          item
          xs={12}
          spacing={1}
          alignItems="top"
          justifyContent="center"
        >
          {" "}
          <Grid item xs={12}>
            <Typography
              className="help"
              component="h6"
              color="primary"
              variant="h6"
            >
              Prescription Template
              <HelpGuideTooltip
                content={
                  <>
                    <Typography component="div" variant="body1">
                      Prescription template
                    </Typography>
                  </>
                }
              />
            </Typography>
          </Grid>
          <Grid
            container
            item
            xs={12}
            spacing={1}
            alignItems="top"
            justifyContent="flex-start"
            marginBottom={1}
          >
            <Grid item xs={12} md={7} textAlign={"left"}>
              <SearchBox className="searchicon">
                <Typography component="label" color="primary" variant="body2">
                  Search by
                </Typography>{" "}
                <TextField
                  id="drugname"
                  name="DrugName"
                  variant="outlined"
                  placeholder="Enter template name"
                  onChange={(e) => {
                    setTemplateName(e.target.value);
                  }}
                />{" "}
              </SearchBox>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <DataGridListStyle>
              <DataGrid
                rows={data[0]?.items ?? []}
                headerHeight={36}
                sortingOrder={["desc", "asc"]}
                columns={columns}
                autoHeight
                rowHeight={40}
                disableSelectionOnClick
                getRowId={(row) => row.id ?? uuid()}
                loading={loading}
                error={error || undefined}
                components={{
                  NoRowsOverlay: NoRecords,
                  NoResultsOverlay: NoRecords,
                  ErrorOverlay: ErrorOverlay,
                }}
                rowsPerPageOptions={[10]}
                paginationMode="server"
                page={page}
                pageSize={pageSize}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                onPageChange={(newPage) => {
                  setPage(newPage);
                }}
                rowCount={rowCountState}
                getRowClassName={(params) => {
                  if (params.row.obsoleteDrug) {
                    return "OP";
                  }
                  return "";
                }}
              />
            </DataGridListStyle>
          </Grid>
          <Grid item xs={12}>
            <BtnGroupStyle className="middle">
              <YSButton
                onClick={() => {
                  handleShowAddNewTemplatePopup();
                  setIsEdit(false);
                }}
                className=""
                children={"Add New Template"}
                size={"large"}
                type="button"
                color="primary"
                variant="contained"
              />{" "}
            </BtnGroupStyle>
          </Grid>
        </Grid>{" "}
      </ContentStyle>
      <DialogPopup
        windowsize={"sm"}
        show={addNewTemplatePopup}
        title={isEdit ? "Edit Template" : "Add New Template"}
        handleShowPopupClick={handleShowAddNewTemplatePopup}
        handleHidePopupClick={handleHideAddNewTemplatePopup}
        close={true}
      >
        <AddNewTemplate
          handleHideAddNewTemplatePopup={handleHideAddNewTemplatePopup}
          fetchApi={fetchApi}
          rowData={rowData}
          isEdit={isEdit}
        />
      </DialogPopup>
      <DialogPopup
        windowsize={"sm"}
        show={deleteDataPopup}
        handleShowPopupClick={handleShowDeletePopupClick}
        handleHidePopupClick={handleHideDeletePopupClick}
        close={true}
      >
        <ConfirmPopup
          deleteRowData={deleteRowData}
          handleHideDeletePopupClick={handleHideDeletePopupClick}
        />
      </DialogPopup>
      <YSSnackBar
        message={deleteStateData.message}
        variant={deleteStateData.variant}
        open={deleteStateData.open}
        handleClose={() => {
          setDeleteStateData((prevState: any) => {
            return { ...prevState, open: false };
          });
        }}
      />
    </>
  );
}
